// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"e42e7128","122":"a82080e3","322":"f3111b4f","453":"ac7ac72b","465":"659f016c"}[chunkId] + ".chunk.js";
};